import moment from 'moment'

export const data = () => ({
  isDebug: true,
  loading: false,
  surveyHeaderID: 0,
  surveyHeaderName: '',
  newId: 0,
  activeStep: 0,
  isSimple: false,
  toggle: false,
  questionToggle: false,
  questionOptionToggle: false,
  selectedSection: null,
  selectedSectionID: 0,
  sections: null,
  formatDateFn: function(value) {
    return value != null ? moment(value, 'YYYY/MM/DD HH:mm:ss').format('MM-DD-YYYY') : ''
  },

  filters: {
    show: false
  },

  region: {},

  rows: [],

  columns: [
    {
      field: '',
      label: '',
      aria: '',
      width: '10%'
    },
    {
      field: 'name',
      label: 'Name',
      aria: 'Name',
      width: '70%',
      sortable: true,
      searchable: true
    }
  ],

  styles: {
    filterButton: {
      float: 'right',
      marginTop: '4px'
    }
  }
})
